import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalVar } from '../../globals/global-var';
import { Register } from '../../models/register';
import { SelfService } from '../../services/self.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  constructor(private http: HttpClient,
    private selfService: SelfService,
    private router: Router,
    private fb: FormBuilder,
    public globalVar: GlobalVar) { }


  ngOnInit(): void {
  }

  registerForm = this.fb.group({
    id: ['', [Validators.required, Validators.minLength(3)]],
    password: ['', Validators.required],
    passwordCheck: ['', Validators.required],
    name: ['', Validators.required],
    email: ['', Validators.required],
    picture: [''],
    department: [''],
    phone: [''],
    address: [''],
    taxId: [''],
    dbName: [''],
   
  });

  postRegister(registerForm: Register): void {
    console.log(registerForm);
    this.selfService.postRegisterApi(registerForm)
      .subscribe(
        result => {
          alert(result.message);
        },
        err => {
          alert(JSON.stringify(err.error));
        },
        () => {
          this.registerForm.reset();
          this.router.navigate(['/home']);
        }
      );
  }

  //檔案上傳
  uploadFile($event) {
    if ($event.target.files.length > 0) {
      const files = $event.target.files;
      if (!files) {
        return;
      }
      let formData: FormData = new FormData();
      formData.append('Files', files);
      for (let i = 0; i < files.length; i++) {
        let singleFile = files.item(i);
        // files 这个名字和spring mvc controller参数的名字要对应  
        formData.append('files', singleFile);
      }
      //檔案上傳
      this.http.post<any>(this.globalVar.targetIp + '/api/file', formData)
        .subscribe(
          result => {
            this.registerForm.patchValue({
              picture: result.檔案名稱
            });
          },
          err => alert(err.error)
        );
      //上傳後將檔案清除
      $event.target.value = '';
    }
  }

}
